import React, { useEffect, useState } from "react";
import {
  Typography,
  Table,
  TableCell,
  CardHeader,
  TableRow,
  IconButton,
  Grid,
  Card,
  CardContent,
  Box,
  Menu,
  MenuItem,
  CircularProgress,
} from "@mui/material";
import Controls from "../../../atoms/Controls";
import { Edit, MoreVert } from "@mui/icons-material";
import moment from "moment";
import { observer } from "mobx-react";
import FlatCard from "../../../atoms/FlatCard";
import { FlexListContainer, LabelItem, ValueItem } from "../../../molecules/FlexList";
import PrivateView from "./RxForms/Private/PrivateView";
import BG from "./RxForms/BG/BG";
import Verordnung13 from "./RxForms/Kasse/Verordnung13";
import Bundeswehr from "./RxForms/Bundeswehr/Bundeswehr";
import Zahnarzt from "./RxForms/Zahnarzt/Zahnarzt";
import { RxStoreContext } from "../../../stores/Rx/rx.provider";
import useStore from "../../../helpers/useStore";
import { NoteDto, RxDtoProcessingStatusEnum } from "../../../api-client";
import Notes from "../../ScheduleOverview/Notes/Notes";
import { NotesContext } from "../../../stores/Notes/notes.provider";
import { UserContext } from "../../../stores/User/User.provider";
import Blankoverordnung from "./RxForms/Blankoverordnung/Blankoverordnung";
import RxStatusNotification from "./RxStatusNotification";
import notificationStore from "../../../stores/Notification/notificationStore";
import { TransactionsContext } from "../../../stores/Transactions/Transactions.provider";
import { BillChip } from "../../../atoms/Chip";
import { PatientsContext } from "../../../stores/Patients/patients.provider";
import DialogBoxAppointment from "../../PrintAppointment/printRxDialogBox";
import WarningDialog from "../../../atoms/WarningDialog";
import TicketForm from "../../Ticketing/TicketEditCreate/ticketForm";
import { useRx, useRxDeletable } from "../../../stores/Rx/rx.queries";
import { usePatient } from "../../../stores/Patients/patient.queries";
import { useMasterTables } from "../../../stores/MasterTables/masterTables.queries";
import { useCopyToContinuous, useDeleteRx, useUpdateRxProcessingStatus } from "../../../stores/Rx/rx.mutations";
import CreateTicketForm from "../../Ticketing/TicketEditCreate/createTicketForm";
import PatientBillDetailsModal from "../../pages/PatientBills/dialogs/PatientBillDetailsModal";
import StartDoctorReportDialog from "../../PatientDocumentation/doctorReport/StartDoctorReportDialog";
import PatientBillDetailsModalShad from "@/components/pages/PatientBills/dialogs/PatientBillDetailsModalShad";
import { therapyRxTermLabel } from "../../../helpers/therapyRxLabel";
import { useMasterTablesFacade } from "../../../stores/MasterTables";

interface RowDetailsProps {
  editRxMode?: boolean;
  setEditRxMode?: any;
  handleDoctorReportView?: (rxId: string) => void;
  selectedRxId?: string;
  patientId?: number;
}

const RxRowOverview: React.FC<RowDetailsProps> = observer(
  ({
    editRxMode,
    setEditRxMode,
    handleDoctorReportView,
    selectedRxId,
    patientId,
  }) => {
    // Get rxId from PatientsContext store
    // const PatientsStore = useStore(PatientsContext);
    // const { selectedRxId, selectedPatientId } = PatientsStore;

    // Get master data using hook
    const { data: masterData, isLoading: isMasterDataLoading } = useMasterTables();

    // Fetch RX data using the rxId from store
    const { data: rowData, isLoading, error: rxError } = useRx(selectedRxId!);

    const isRxLoading = isLoading || isMasterDataLoading;
    // Get patient data from store
    const { data: patientValues } = usePatient(patientId!);

    const TransactionStore = useStore(TransactionsContext);
    const { unpaidBills } = TransactionStore;
    const unpaidRx = unpaidBills.find(
      (bill) => bill.rxId?.toString() === selectedRxId && bill.dueAmount > 0
    );
 

    const { mutate: copyToContinous } = useCopyToContinuous();

    // Use the new mutation for updating processing status
    const updateProcessingStatusMutation = useUpdateRxProcessingStatus();
    const { mutate: deleteRx } = useDeleteRx();

    // Menu state for context menu
    const [menu, setMenu] = useState<null | HTMLElement>(null);
    const [openTicket, setOpenTicket] = useState<any>(false);
    const [showDialogBoxAppointment, setShowDialogBoxAppointment] = useState<boolean>(false);
    const [showDeleteWarning, setShowDeleteWarning] = useState(false);
    const {
      data: deletionCheck,
      isLoading: isDeletionCheckLoading,
    } = useRxDeletable(selectedRxId, showDeleteWarning);
    const deletionBlockers = deletionCheck?.blockers ?? [];
    const canDeleteRx = !isDeletionCheckLoading && deletionBlockers.length === 0;
    const [isRestoreStateLoading, setIsRestoreStateLoading] = useState(false);
    const [showBillingTimeline, setShowBillingTimeline] = useState(false);
    const [showStartDoctorReportDialog, setShowStartDoctorReportDialog] = useState(false);
    const PatientStore=useStore(PatientsContext);
    const {setSelectedRxId}=PatientStore;

    const [openRxStatusNotfication, setOpenRxStatusNotification] = useState(false);
    const [selectedRxStatus, setSelectedRxStatus] = useState<RxDtoProcessingStatusEnum | undefined>();

    const handleCloseRxStatusNotification = () => {
      setOpenRxStatusNotification(false);
    };

    // Menu handlers
    const handleMoreButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
      setMenu(event.currentTarget);
    };

    const handleMenuClose = () => {
      setMenu(null);
    };

    const handleCreateVirtualPrescription = async () => {
      if (!selectedRxId) return;

      try {
        copyToContinous({ rxId: selectedRxId, patientId: patientId! });
        handleMenuClose();
        //   // Refresh patient data
        //   if (setPatientData && handleData && patientValues) {
        //     // const updatedRxs = [...(patientValues?.rxs || []), response];
        //     const updatedPatientData = { ...patientValues, rxs: updatedRxs };
        //     setPatientData(updatedPatientData);
        //     handleData(updatedPatientData);
        //   }
      } catch (error) {
        console.error("Error creating virtual prescription:", error);
      }
    };

    const handleDeleteRx =  () => {
      if (!selectedRxId) return;

      try {
        deleteRx({ rxId: selectedRxId, patientId: patientId! });
        setSelectedRxId(null);
        handleMenuClose();
        setShowDeleteWarning(false);
        // // Refresh patient data if handlers available
        // if (setPatientData && handleData && patientValues) {
        //   const updatedRxs = (patientValues?.rxs || []).filter((rx: any) => rx.id !== selectedRxId);
        //   const updatedPatientData = { ...patientValues, rxs: updatedRxs };
        //   setPatientData(updatedPatientData);
        //   handleData(updatedPatientData);
        // }
      } catch (error) {
        console.error("Error deleting rx:", error);
      }
    };

    const handleShowAppointment = () => {
      setShowDialogBoxAppointment(true);
      handleMenuClose();
    };

    const handleHideAppointment = () => {
      setShowDialogBoxAppointment(false);
    };
    const renderBooleanProperty = (label: string, value: boolean) => {
      if (value === true) {
        return (
          <TableRow>
            <TableCell sx={{ fontWeight: "bold" }}>{label}</TableCell>
            {/* <TableCell>{value.toString()}</TableCell> */}
          </TableRow>
        );
      }
      return null;
    };

    const updateRxProcessingStatus = async (event: any) => {
      try {
        if (event.target.value === RxDtoProcessingStatusEnum.Abgebrochen || event.target.value === RxDtoProcessingStatusEnum.Abgerechnet) {
          setOpenRxStatusNotification(!openRxStatusNotfication);
          setSelectedRxStatus(event.target.value);
        } else if (Object.values(RxDtoProcessingStatusEnum).includes(event?.target.value)) {
          // Use the new mutation instead of the store method
          updateProcessingStatusMutation.mutate({
            rxId: selectedRxId!,
            status: event?.target.value,
            appointmentIds: [],
            patientId: patientId!,
          });
        }
      } catch (error) {
        notificationStore.showMessage("Fehler beim Aktualisieren des Bearbeitungsstatus", "error");
      }
    };
    const UserStore = useStore(UserContext);
    const { user } = UserStore;
    // MD-325: turns the line's chosen line-item id into the abbreviation the
    // planner recognises, without a request per prescription line.
    const { getTherapyAbbreviationById } = useMasterTablesFacade();
    const NotesStore = useStore(NotesContext);
    const { getRxNotes, updateNoteById, postNotes, fetchNotes } = NotesStore;
    const [rxNotes, setRxNotes] = useState<NoteDto[]>([]);
    useEffect(() => {
      const fetchData = async () => {
        try {
          if (selectedRxId) {
            const response = await getRxNotes(selectedRxId);

            setRxNotes(response);
          }
        } catch (error) {
          // console.log("error", error);
        }
      };

      fetchData();
    }, [selectedRxId, fetchNotes]);

    const updateNote = async (index: number, updatedCard: NoteDto) => {
      updatedCard.rxId = selectedRxId;
      if (updatedCard.id) {
        await updateNoteById(updatedCard.id, user?.id as string, updatedCard);
      } else {
        await postNotes(user?.id as string, updatedCard);
      }
      const updatedNotes = [...rxNotes];
      updatedNotes[index] = updatedCard;
      setRxNotes(updatedNotes);
    };

    const renderRxComponent = () => {
      switch (rowData?.rxtype?.id) {
        case "Privat/Selbstzahler":
          return (
            <PrivateView
              selectedRow={rowData}
              patientData={patientValues}
              updateRxProcessingStatus={updateRxProcessingStatus}
            />
          );
        case "Berufsgenossenschaft":
          return (
            <BG
              selectedRxId={selectedRxId}
              patientId={patientId}
              readOnlyView
              updateRxProcessingStatus={updateRxProcessingStatus}
            />
          );
        case "Kasse":
        case "Entlassmanagement":
          return (
            <Verordnung13
              selectedRxId={selectedRxId}
              patientId={patientId}
              readOnlyView={true}
              updateRxProcessingStatus={updateRxProcessingStatus}
              // ref={saveGenericViewData}
            />
          );
        case "Blankoverordnung":
          return (
            <Blankoverordnung
              selectedRxId={selectedRxId}
              patientId={patientId}
              readOnlyView={true}
              updateRxProcessingStatus={updateRxProcessingStatus}
              // ref={saveGenericViewData}
            />
          );
        case "Bundeswehr":
          return (
            <Bundeswehr
              selectedRxId={selectedRxId}
              patientId={patientId}
              readOnlyView={true}
              updateRxProcessingStatus={updateRxProcessingStatus}
              // ref={saveGenericViewData}
            />
          );
        case "Zahnarzt":
          return (
            <Zahnarzt
              selectedRxId={selectedRxId}
              patientId={patientId}
              readOnlyView={true}
              updateRxProcessingStatus={updateRxProcessingStatus}
              // ref={saveGenericViewData}
            />
          );

        // Add other cases for different rxtypes as needed
        default:
          return (
            <Grid container spacing={1}>
              <Grid item xs={12} md={6} sx={{ border: "0px solid green" }}>
                {rowData && (
                  <FlexListContainer>
                    <LabelItem label="Rx Datum" />
                    <ValueItem
                      value={
                        rowData.date
                          ? moment(rowData.date, "YYYY-MM-DD", true).isValid()
                            ? moment(rowData.date).format("DD.MM.YYYY")
                            : rowData.date
                          : "-"
                      }
                    />
                    <LabelItem label="Eingegeben am" />
                    <ValueItem  value={
                        rowData.createdAt
                          ? moment(rowData.createdAt, "YYYY-MM-DD", true).isValid()
                            ? moment(rowData.createdAt).format("DD.MM.YYYY")
                            : rowData.createdAt
                          : "-"
                      }
                    />
                    <LabelItem label="Behandlungsort" />
                    <ValueItem
                      value={
                        rowData.isHomeVisit === true
                          ? "Haus/Heim"
                          : rowData.isHomeVisit === false
                          ? "Praxis"
                          : "-"
                      }
                    />
                    <LabelItem label="Mandant" />
                    <ValueItem value={rowData.account?.name || "-"} />
                    <LabelItem label="Rezeptverbleib" />
                    <ValueItem value={rowData?.status || "-"} />

                    <LabelItem label="Kostenträger" />
                    <ValueItem value={rowData?.payer?.name || "-"} />
                    <LabelItem label="IK Nummer" />
                    <ValueItem value={rowData?.payer?.ik || "-"} />
                    <LabelItem label="Tarif Group" />
                    <ValueItem value={rowData?.tarifGroupId || "-"} />
                    <LabelItem label="Versichertennummer" />
                    <ValueItem value={rowData.insureeNumber || patientValues?.insuranceNo} />
                    <LabelItem label="Status" />
                    <ValueItem value={rowData?.insuranceStatus || "-"} />
                    <LabelItem label="Arzt" />
                    <ValueItem
                      value={
                        `${rowData?.doctor?.contactInfo?.firstNames || " "} ${
                          rowData?.doctor?.contactInfo?.lastName || " "
                        }` || "-"
                      }
                    />
                    <LabelItem label="Rezept-Typ" />
                    <ValueItem value={rowData.rxtype?.id || "-"} />
                    <LabelItem label="LANR" />
                    <ValueItem value={rowData?.LANR || "-"} />
                    <LabelItem label="BSNR" />
                    <ValueItem value={rowData?.BSNR || "-"} />
                    <LabelItem label="TextDiagnose" />
                    <ValueItem value={rowData?.diagnosisText || "-"} />
                    <LabelItem label="ICDCodes" />
                    <ValueItem
                      value={
                        (rowData || [])?.icdCodeEntries
                          ?.map((icd: any) => icd.userText)
                          .join(", ") || "-"
                      }
                    />
                    <LabelItem label="DiagnoseGruppe" />
                    <ValueItem value={rowData?.diagnosegroup?.code || "-"} />

                    <LabelItem label="Optionen" />
                    <ValueItem
                      value={[
                        rowData?.isPerpetualApproved ? "Langfristgenehmigung" : "",
                        rowData?.isCopaymentExempted ? "Zuzahlungsfrei" : "",
                        rowData?.isAccident ? "Unfallfolgen" : "",
                        rowData?.isBVG ? "BVG" : "",
                        rowData?.problematic ? "auf Kontrolle" : "",
                        rowData?.changeRequested ? "auf zum Ändern" : "",
                        rowData?.therapyReport ? "Therapiebericht" : "",
                        rowData?.urgent ? "Dringlicher Behandlungsbedarf" : "",
                        rowData?.hygiene ? "Hygieneposition" : "",
                      ]
                        .filter(Boolean)
                        .join(", ")}
                    />
                  </FlexListContainer>
                )}
              </Grid>
              <Grid item xs={12} md={6}>
                <FlatCard title="Behandlungen">
                  <Table>
                    <TableRow>
                      <TableCell>Heilm.</TableCell>
                      <TableCell>Menge</TableCell>
                      <TableCell>Frequency</TableCell>
                    </TableRow>
                    {rowData?.therapyRxs
                      ?.slice()
                      .sort((a: any, b: any) => a.order - b.order)
                      .map((therapyRx: any, index: number) => (
                        <TableRow key={index}>
                          <TableCell>
                            {therapyRxTermLabel(therapyRx)}
                            {/* MD-325: when the prescribed term is an umbrella
                                ("Wärme"), show WHICH application this Rx is
                                delivered as. Before this the planner could only
                                find out by opening individual appointments —
                                and the answer differed between them. */}
                            {getTherapyAbbreviationById(therapyRx?.chosenTherapyId) && (
                              <Typography
                                component="span"
                                variant="caption"
                                sx={{ ml: 0.5, color: "text.secondary" }}
                                title={
                                  therapyRx?.therapyIsManuallyChosen
                                    ? "Festgelegte Anwendung für diese Verordnungszeile"
                                    : "Automatisch gewählte Anwendung, für neue Termine übernommen"
                                }
                              >
                                ({getTherapyAbbreviationById(therapyRx?.chosenTherapyId)})
                              </Typography>
                            )}
                          </TableCell>
                          <TableCell>{therapyRx?.amount}</TableCell>
                          <TableCell>{therapyRx?.frequency?.text}</TableCell>
                        </TableRow>
                      ))}
                  </Table>
                </FlatCard>
                <Grid item xs={12}>
                  <Controls.Select
                    name="processingStatus"
                    label="Status"
                    onChange={updateRxProcessingStatus}
                    value={rowData?.processingStatus || RxDtoProcessingStatusEnum.InBehandlung}
                    options={Object.values(RxDtoProcessingStatusEnum).map((value) => ({
                      value: value,
                      label: value,
                    }))}
                    noTriggerChange={true}
                    // style={{
                    //   width: "100%",
                    //   marginTop: "0px",
                    //   marginBottom: "0px",
                    //   fontSize: "10px",
                    // }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <FlatCard
                    title="Rezepthinweise"
                    sxContent={{ p: 0.75 }}
                    sx={{
                      paddingTop: "5px",
                      marginBottom: "8px",
                      textAlign: "left",
                    }}
                  >
                    <Notes notes={rxNotes} setNotes={updateNote} maxVisibleNotes={3} noteKind="Rezepthinweis" />
                  </FlatCard>
                </Grid>
              </Grid>
            </Grid>
          );
      }
    };
       if (isRxLoading) {
         return (
           <Box display="flex" justifyContent="center" alignItems="center" p={3}>
             <CircularProgress />
           </Box>
         );
       }
    return (
      <Card sx={{ borderRadius: "10px" }}>
        <CardHeader
          title={
            <Box sx={{ display: "flex", alignItems: "center", gap: 3 }}>
              <Typography variant="subtitle1">Rezept - {rowData?.rxNumber}</Typography>
              {unpaidRx && (
                <BillChip
                  amount={unpaidRx.dueAmount}
                  isCopayment={unpaidRx.tarifGroupId === "GKV"}
                />
              )}
            </Box>
          }
          sx={{ height: "40px" }}
          action={
            <>
              <IconButton onClick={() => setEditRxMode(!editRxMode)}>
                <Edit />
              </IconButton>
              <IconButton onClick={handleMoreButtonClick}>
                <MoreVert />
              </IconButton>
            </>
          }
        />

       <CardContent>
          {renderRxComponent()}
          <RxStatusNotification
            open={openRxStatusNotfication}
            selectedStatus={selectedRxStatus}
            onClose={handleCloseRxStatusNotification}
            rxData={rowData!}
            patientId={patientId!}
          />
        </CardContent>
         

        {/* Context Menu */}
        <Menu anchorEl={menu} open={Boolean(menu)} onClose={handleMenuClose}>
          <MenuItem onClick={handleCreateVirtualPrescription} disabled={rowData?.isPerpetual}>
            Dauerrezept anlegen
          </MenuItem>
          {rowData?.deletedAt === null && (
            <MenuItem onClick={() => setShowDeleteWarning(true)}>Rezept löschen</MenuItem>
          )}
          {rowData?.deletedAt && (
            <MenuItem
              disabled={isRestoreStateLoading}
              onClick={() => {
                // Handle restore if needed
                handleMenuClose();
              }}
            >
              Rezept wiederherstellen
            </MenuItem>
          )}
          <MenuItem
            onClick={() => {
              setOpenTicket(!openTicket);
              handleMenuClose();
            }}
          >
            Ticket erstellen
          </MenuItem>
          <MenuItem onClick={handleShowAppointment}>Termin Ausdrucken</MenuItem>
          {handleDoctorReportView && (
            <MenuItem
              onClick={() => {
                if (handleDoctorReportView) {
                  handleDoctorReportView(selectedRxId!);
                }
                handleMenuClose();
              }}
            >
              Therapiebericht hinzufügen
            </MenuItem>
          )}
          <MenuItem
            onClick={() => {
              setShowStartDoctorReportDialog(true);
              handleMenuClose();
            }}
          >
            Therapiebericht starten
          </MenuItem>
          <MenuItem
            onClick={() => {
              setShowBillingTimeline(true);
              handleMenuClose();
            }}
          >
            Transaktionen
          </MenuItem>
        </Menu>

        {/* Dialog components */}
        {showDialogBoxAppointment && (
          <DialogBoxAppointment
            id={selectedRxId}
            openDialog={showDialogBoxAppointment}
            handleOnClose={handleHideAppointment}
            single={true}
            tarifId={patientValues?.tarifGroupId}
            rxDate={rowData?.date}
          />
        )}

        {showDeleteWarning && (
          <WarningDialog
            open={showDeleteWarning}
            onClose={() => setShowDeleteWarning(false)}
            onContinue={canDeleteRx ? handleDeleteRx : undefined}
            loading={isDeletionCheckLoading}
            title="Rezept löschen"
            content={
              isDeletionCheckLoading
                ? "Löschprüfung läuft …"
                : deletionBlockers.length > 0
                ? `Dieses Rezept kann nicht gelöscht werden: ${deletionBlockers
                    .map((b) => b.message)
                    .join(" ")}`
                : "Sind Sie sicher, dass Sie dieses Rezept löschen möchten?"
            }
          />
        )}

        {/* Billing Timeline Modal */}
        {showBillingTimeline && selectedRxId && (
          <PatientBillDetailsModalShad
            open={showBillingTimeline}
            onClose={() => setShowBillingTimeline(false)}
            rxId={selectedRxId}
            rxNumber={rowData?.rxNumber}
          />
        )}

        {/* Ticket Form */}
        {openTicket && (
          <CreateTicketForm
            openTicket={openTicket}
            onCloseTicketForm={() => setOpenTicket(false)}
            data={{ patient: patientValues, patientId: patientValues?.id, rx: rowData ,rxId:rowData?.id}}
          />
        )}

        {/* Start Doctor Report Dialog */}
        {showStartDoctorReportDialog && selectedRxId && (
          <StartDoctorReportDialog
            open={showStartDoctorReportDialog}
            onClose={() => setShowStartDoctorReportDialog(false)}
            rxId={selectedRxId}
            onCreated={(reportId) => {
              if (handleDoctorReportView) {
                handleDoctorReportView(selectedRxId);
              }
            }}
          />
        )}
      </Card>
    );
  }
);

export default RxRowOverview;
